import React from 'react';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';
import { ColorUtil } from '../../../utils/color-util';

import type { ListBackgrounds } from './List';

export type ListItemProps = {
  children: React.ReactNode;
  background?: ListBackgrounds;
  className?: string;
  name?: string;
  onClick?: () => void;
  selected?: boolean;
  title?: string;
};

export const ListItem = ({
  background,
  children,
  className,
  name = 'LIST_ITEM',
  onClick,
  selected = false,
  title,
}: ListItemProps) => (
  <li
    className={AttrsHelper.formatClassname(
      'list-item',
      background &&
        ColorUtil.nameClass({ color: background, prefix: 'background' }),
      selected && 'selected',
      onClick && 'clickable',
      className
    )}
    data-test={name}
    onClick={onClick}
    title={title}
  >
    {children}
  </li>
);
